import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../common'

const DOC = gql`
  ${common.gql.dms.data.fragments.variable.DOC}
  query Apps($zoneId: ID!, $tenantId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        apps {
          items {
            id
            alias
            description
            icon
            name
            createdBy
            sessionVariables {
              ...FragmentVariable
            }
            supportsScenarios
            supportsFunctionalityConfiguration
          }
          nextCursor
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.AppsQuery,
    ents.core.common.Response.For.Pagination<ents.core.admin.App>,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'apps',
        graphql.transformers.OUT.object({
          items: graphql.transformers.OUT.default(
            graphql.transformers.OUT.list(
              graphql.transformers.OUT.object({
                alias: graphql.transformers.OUT.validate(
                  transformers.PASS_THROUGH,
                  TypeAsserter.assertIsNotNullish,
                  { warnOnly: true },
                ),
                description: transformers.PASS_THROUGH,
                createdBy: transformers.PASS_THROUGH,
                icon: graphql.transformers.OUT.validate(
                  transformers.PASS_THROUGH,
                  TypeAsserter.assertIsNotNullish,
                  { warnOnly: true },
                ),
                id: graphql.transformers.OUT.validate(
                  transformers.PASS_THROUGH,
                  TypeAsserter.assertIsNotNullish,
                  { warnOnly: true },
                ),
                name: graphql.transformers.OUT.validate(
                  transformers.PASS_THROUGH,
                  TypeAsserter.assertIsNotNullish,
                  { warnOnly: true },
                ),
                // TODO: Scenario variables should probably be removed
                scenarioVariables: () => [],
                sessionVariables: graphql.transformers.OUT.validate(
                  graphql.transformers.OUT.list(
                    common.gql.dms.data.fragments.variable.TRANSFORMER,
                    { onNullish: 'remove' },
                  ),
                  TypeAsserter.assertIsNotNullish,
                  { warnOnly: true },
                ),
                supportsScenarios: graphql.transformers.OUT.validate(
                  transformers.PASS_THROUGH,
                  TypeAsserter.assertIsNotNullish,
                  { warnOnly: true },
                ),
                supportsFunctionalityConfiguration: transformers.PASS_THROUGH,
              }),
              {
                onNullish: 'remove',
              },
            ),
            [],
          ),
          nextCursor: transformers.PASS_THROUGH,
        }),
      ),
    ),
  ),
  {
    items: [],
    nextCursor: undefined,
  },
)

export const execute = graphql.createExecutor<
  graphql.schema.AppsQuery,
  ents.core.common.Response.For.Pagination<ents.core.admin.App>,
  graphql.schema.AppsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
